import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ColumnChartComponent } from '@connect-services/client/components/statistics/column-chart/column-chart.component';
import { GaugeChartComponent } from '@connect-services/client/components/statistics/gauge-chart/gauge-chart.component';
import { LineChartComponent } from '@connect-services/client/components/statistics/line-chart/line-chart.component';
import { PieChartComponent } from '@connect-services/client/components/statistics/pie-chart/pie-chart.component';
import { ValueChartComponent } from '@connect-services/client/components/statistics/value-chart/value-chart.component';
import { ComputedStatistic } from '@connect-services/src/sdk/api';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ColumnChartComponent, GaugeChartComponent, LineChartComponent, PieChartComponent, ValueChartComponent],
    selector: 'app-chart',
    templateUrl: './chart.component.html',
})
export class ChartComponent {
    public readonly computedStatistic = input.required<ComputedStatistic>();
    public readonly isExpanded = input.required<boolean>();
    public ready = output<void>();
    public readonly showLabels = input<boolean>(false);

    protected readonly RenderEnum = ComputedStatistic.RenderEnum;

    public onReady(): void {
        this.ready.emit();
    }
}
